const Backbone = require('backbone');
require('backbone.marionette');
const _ = require('underscore');
const UserModel = require('common/domain/entity/user');
const ModalView = require('common/ui/view/modal/index');
const UserSettingModal = require('common/ui/view/modal/user-setting');
const IdeaModal = require('feedback/ui/view/modal/idea');
const UserMenuTemplate = require('common/ui/template/header/user.hbs');
const UserEmailAddRequestModal = require('balus/ui/view/body/user-email-activation/modal/user-email-add-request-view');
const i18n = require('i18next');
const DebugContextRepository = require('common/util/debug-context/debug-context-repository');
const AppRouter = require('balus/app/router/index');

module.exports = Backbone.Marionette.View.extend({
    model: UserModel,
    tag: null,
    template: false,
    ui: {
        changeUserAccounts: '.change-user-accounts',
        userSetting: '.user-setting',
        idea: '.idea',
        addEmailAddress: '.add-email-address',
        configureReverseProxy: '.configure-reverse-proxy-target'
    },
    events: {
        'click @ui.changeUserAccounts': 'changeUserAccounts',
        'click @ui.userSetting': 'showSetting',
        'click @ui.idea': 'showIdea',
        'click @ui.addEmailAddress': 'showAddEmailAddress',
        'click @ui.configureReverseProxy': 'configureReverseProxy'
    },

    render: function() {
        if (this.model && this.model.id) {
            const debugContext = (new DebugContextRepository()).fetch();
            const json = this.model.toJSON();
            json.isSiteAdmin = this.model.isSiteAdmin();
            json.debugContext = debugContext.toTemplateContext();

            json.showFeedbackAdmin = json.isSiteAdmin || json.admin_permissions && json.admin_permissions['admin:feedback:all'];
            json.adminDivider = json.isSiteAdmin || json.showFeedbackAdmin;

            this.setElement($(UserMenuTemplate(json)));
            this.$('[data-toggle="tooltip"]').tooltip();

            $.material.init();
        }

        return this;
    },

    changeUserAccounts: function() {
        const currentLocation = window.location.pathname + window.location.search + window.location.hash;
        AppRouter.navigate(`/accounts?dst_url=${encodeURIComponent(currentLocation)}`, { trigger: true });
    },

    showSetting: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('title.user.setting'),
            saveButtonEnable: true,
            bodyView: new UserSettingModal({user: this.model}),
            onChildviewSave: function() {
                if(this.getOption('bodyView').setting()) {
                    this.disableButtons();
                    this.hide();
                }
            }
        });
        modal.show();
    },

    showIdea: function() {
        const modal = new ModalView({
            title: i18n.t('title.user_request.create'),
            bodyView: new IdeaModal(),
            onChildviewSave: function() {
                this.getOption('bodyView').setting()
                    .then(() => {
                        this.disableButtons();
                        this.hide();
                    })
            }
        });
        modal.show();
    },

    showAddEmailAddress: function() {
        const modal = new ModalView({
            title: i18n.t('balus_template_body_user_email_activation:modal.title'),
            bodyView: new UserEmailAddRequestModal(),
            onChildviewSave: function() {
                this.disableButtons();

                const bodyView = this.getOption('bodyView');
                bodyView.save()
                    .then(() => {
                        bodyView.onSuccess(() => {
                            modal.hide();
                        });
                    }).catch(response => {
                        bodyView.onFailed(response);
                        this.enableButtons();
                    });
            }
        });

        modal.show();
    },

    configureReverseProxy: function () {
        let target = prompt("リバースプロキシ先のターゲットバージョンを指定してください。" +
            "デフォルト値を利用するには、空文字にしてください。");
        if (!target) {
            target = "";
        }

        let url = location.href.split('?')[0];
        url += `?debug=enabled&tngVersion=${target}`;

        location.href = url;
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/header/user.js